// In-app browsers (social apps' built-in WebViews) can't "Add to Home Screen",
// so users must first open the page in Safari/Chrome.
const IN_APP_BROWSERS: { name: string; pattern: RegExp }[] = [
  { name: 'Instagram', pattern: /Instagram/i },
  { name: 'Facebook', pattern: /FBAN|FBAV|FB_IAB|FBIOS/i },
  { name: 'Messenger', pattern: /Messenger/i },
  { name: 'Threads', pattern: /Barcelona/i },
  { name: 'Snapchat', pattern: /Snapchat/i },
  { name: 'LinkedIn', pattern: /LinkedInApp/i },
  { name: 'TikTok', pattern: /musical_ly|BytedanceWebview|TikTok/i },
  { name: 'Twitter', pattern: /Twitter/i },
  { name: 'LINE', pattern: /\bLine\//i },
];

/** Name of the app whose built-in browser is in use, or null for a regular browser. */
export const getInAppBrowserName = (userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): string | null =>
  IN_APP_BROWSERS.find(({ pattern }) => pattern.test(userAgent || ''))?.name ?? null;
